import { render } from "./menubarEN.vue?vue&type=template&id=031dd85d&scoped=true"
import script from "./menubarEN.vue?vue&type=script&lang=js"
export * from "./menubarEN.vue?vue&type=script&lang=js"

import "./menubarEN.vue?vue&type=style&index=0&id=031dd85d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031dd85d"]])

export default __exports__